/**
 * Created by Pradeep Kumar on 7/11/2019.
 */

import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {TombOfNefertitiParsedGameData} from "../../server/data/TombOfNefertitiParsedGameData";
import {TombOfNefertitiWildRaidPresentationView} from "./TombOfNefertitiWildRaidPresentationView";
import {TweenLite} from "gsap";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";

export class TombOfNefertitiWildRaidPresentationController extends BeforeSpinStopPresentationController {

    private _view: TombOfNefertitiWildRaidPresentationView;
    private _mode: string;
    private _fakeDelay: number = 0;
    private _presentationStarted: boolean = false;
    private _isTriggered: boolean = false;

    constructor(index: number, name: string, tweakEnabled?: boolean, betWinMode?: BetWinMode) {
        super(index, name, tweakEnabled, betWinMode);

        this._view = new TombOfNefertitiWildRaidPresentationView();
    }

    public abort(abortDetails?: any): void {
        if (this._isTriggered && this._presentationStarted && abortDetails.quickStop) {
            this._view.killTimeLine(this._mode);
            this._presentationStarted = false;
        }

        super.abort(abortDetails);
    }

    protected parseFeatureTriggered(data: TombOfNefertitiParsedGameData): boolean {
        const isTriggered: boolean = data.isWildRaidFeatureTriggered;

        this._mode = data.mode;

        this._view.wildRaidPositions = data.wildRaidPositions;

        this._fakeDelay = TombOfNefertitiGameConfig.instance.START_DELAY_FOR_RESPIN_WIN_SHOW + TombOfNefertitiGameConfig.instance.SPIN_DELAY;
        if (isTriggered) {
            TombOfNefertitiGameConfig.instance.START_DELAY_FOR_RESPIN_WIN_SHOW = 0;
        }

        this._isTriggered = isTriggered;

        return isTriggered;
    }

    protected getSpinStopDelay(data: ParsedGameData): number {
        return 0;
    }

    protected startPresentation(): void {
        TweenLite.to(() => {}, this._fakeDelay, {
            onComplete: () => {
                this._presentationStarted = true;
                this._view.playAnim(this._mode);
            }
        });
    }

    protected stopPresentation(isAborted: boolean): void {
    }
}